module.exports = __webpack_public_path__ + "img/DE01766.fe94521e.svg";